module.exports = __webpack_public_path__ + "media/pdf/scissors-f47053cb.png";